/* src/app/components/processing/platform-activity/panels/case-priorities/case-priorities.component.scss */
.main-panel {
  width: 480px;
  height: 100%;
  background: #2B2B2B;
  z-index: 99;
  right: 0;
}
.step-data {
  color: #FFF;
}
:host-context(.dark-theme) .main-panel {
  background: #363636;
  box-shadow:
    -1px 1px 1px rgba(0, 0, 0, 0.07),
    -2px 1px 3px rgba(0, 0, 0, 0.07),
    -3px 1px 3px rgba(0, 0, 0, 0.07);
}
/*# sourceMappingURL=case-priorities.component.css.map */
